import { IsTest, getLang } from "@/utils/tools";
import { isHtm } from "@/utils/const";
import { request } from "..";

// TODO 请求域名确定
const testOrigin = "https://test-sg-act.playerinfinite.com/";
const prodOrigin = "https://sg-act.playerinfinite.com/";
const origin = IsTest ? testOrigin : prodOrigin;
interface commomRes {
  code: number;
  msg: string;
  data?: any;
}

export interface RoleInfo{
  area_id: string;
  game_id: number;
  game_name: string;
  plat_id: string;
  role_name: string;
  zone_id: string;
  role_id: string;
}

const lang_type = getLang();
export const submitShare = async () => {
  const otherurl = 'api/flow/Wand-20231009061232-F190ca067dfd5';
  const htmlurl = 'api/flow/Wand-20230714065440-Ffb803d471bcf';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

interface GetRoleInfoReq{
  area_id: string;
}
interface GetRoleInfoRes extends commomRes {
  data: {
    role_list: RoleInfo[];
  };
}

// @see https://yapi.intlgame.com/project/1344/interface/api/83796
export const getRoleInfo = async (params: GetRoleInfoReq) => {
  const otherurl = 'api/flow/Wand-20231221025720-F720cc0f8d165';
  const htmlurl = 'api/flow/Wand-20231221113839-F796cf6ee526f';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetRoleInfoRes>(`${origin}${url}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};

type SaveRoleInfoRes = commomRes;
// @see https://yapi.intlgame.com/project/1344/interface/api/83816
export const saveRoleInfo = async (params: Partial<RoleInfo>) => {
  const otherurl = 'api/flow/Wand-20231221025824-F4b22730aea13';
  const htmlurl = 'api/flow/Wand-20231221113927-F8084b4a5d8e4';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<SaveRoleInfoRes>(`${origin}${url}`, params)
    .then((res) => res.data);
};

interface GetLoginedInitInfoRes extends commomRes {
  data: {
    get_saved_role_info: RoleInfo; // 角色信息
  };
}
// TODO htm 待确定
export const getLoginedInitInfo = async () => {
  const otherurl = 'api/flow/Wand-20231221025600-F0f707a7ead5a';
  const htmlurl = 'api/flow/Wand-20231221113834-Fad8ab7abfb23';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetLoginedInitInfoRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const enum RewardType{
  FirstLogin = 0, // 首次登录
  FirstShare = 1,// 首次分享
  FirstTest = 2, // 首次测试
  LoadCutThree = 3,// 加载完第三屏
  LoadCutFour = 4,// 加载完第四屏
  LoadCutFive = 5,// 加载完第5屏
  LoadCutSeven = 7,// 加载完第七屏
  LoadCutEight = 8,// 加载完第八屏
  LoadCutSix = 6,// 第6屏 没有具体奖励 做判断 用
  LoadCutSixBliss = 61,// 第五屏极乐净土礼包
  LoadCutSixTetra = 62,// 第五屏泰特拉礼包
  LoadCutSixMisilis= 63,// 第五屏米西利斯礼包
  LoadCutSixPilgrims = 64,// 第五屏朝圣者礼包
  LoadCutNine = 9,// 加载完第九屏
}

interface getRewardParams{
  tag: RewardType;
}
export const getReward = async () => {
  const otherurl = 'api/flow/Wand-20231221113139-F77c6a08bba0b';
  const htmlurl = 'api/flow/Wand-20231221113846-F7545efc9efa3';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const enum SentimentType {
  Positive = "positive", // 激活
  Negative = "negative", // 取消激活
  Neutral = "neutral", // 取消激活
}
interface RecordMessage0101Res extends commomRes {
  data: {
    result: number;
    sentiment_type: SentimentType;
  };
}
export const RecordMessage0101 = async (message: string) => {
  const url = '/api/proxy_direct/logicial/NikkeTmp/RecordMessage0101';
  return request
    .post<RecordMessage0101Res>(`${origin}${url}`,  {
      checkLogin: false,
      needLogin: false,
      lang_type,
      message,
    })
    .then((res) => res.data);
};